import { render, staticRenderFns } from "./DetailShopInfo.vue?vue&type=template&id=47aff7a8&scoped=true&"
import script from "./DetailShopInfo.vue?vue&type=script&lang=js&"
export * from "./DetailShopInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailShopInfo.vue?vue&type=style&index=0&id=47aff7a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aff7a8",
  null
  
)

export default component.exports